export default __webpack_public_path__ + "static/media/walletconnect-banner.fbe221c1.svg";